import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  right: 0;
  height: 100%;
  background: #ffffff;
  z-index: 999999999;
  width: 50%;
  max-width: 90rem;
  -webkit-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  transform: translateX(0);
  transition: all 0.5s ease;

  .offline-chat {
    font-size: 1.6rem;
  }

  &.minimizado {
    transform: translateX(calc(100% + 5rem));
  }

  .nenhuma-conversa {
    width: 80%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eef3f9;
    font-size: 1.5rem;

    p {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: rgba(0, 0, 0, 0.6);

      i {
        font-size: 11rem;
        margin-bottom: 2rem;
      }
    }
  }
`;

export const Login = styled.div`
  display: flex;
  flex-direction: column;
  background: #eceff1;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: normal;
`;

export const Close = styled.div`
  width: 50px;
  height: 50px;
  background: #eceff1;
  border-radius: 5px 0 0 5px;
  position: absolute;
  left: -5rem;
  -webkit-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: rgba(0, 0, 0, 0.4);
`;

export const Settings = styled.div`
  width: 50px;
  height: 50px;
  top: 54px;
  background: #eceff1;
  border-radius: 5px 0 0 5px;
  position: absolute;
  left: -5rem;
  -webkit-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  box-shadow: -5px 0px 5px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: rgba(0, 0, 0, 0.4);
`;



// WEBPACK FOOTER //
// ./src/components/ChatContainer/styles.js